import { ZFutureDateString } from 'shared/models/validations';

import { Checkout } from '../paymentScreen.models';

export const isValidStartDateCheckout = (checkoutInfo?: Checkout) => {
  if (checkoutInfo?.policies[0].proratedStartDate) {
    const startDateValidationResult = ZFutureDateString.safeParse(
      checkoutInfo?.policies[0].proratedStartDate
    );
    return startDateValidationResult?.success;
  }

  return true;
};
